import styles from './ApplicationMain.module.css'
import type { ReactNode } from 'react'

interface ApplicationMainProps {
    children?: ReactNode;
}

export const ApplicationMain = (props: ApplicationMainProps) => {
    const {
        children
    } = props

    return (
        <main className={styles.ApplicationMain__Root}>
            {children}
        </main>
    )
}